angular.module('controllers').controller('chatController', ['$scope', '$rootScope', '$controller', 'Crud', '$mdDialog', '$filter', '$http', '$route', '$routeParams', '$location', '$timeout', '$interval', '$window', 'Mqtt',
	function ($scope, $rootScope, $controller, Crud, $mdDialog, $filter, $http, $route, $routeParams, $location, $timeout, $interval, $window, Mqtt) {

		Mqtt.connect($rootScope.mq);

		$rootScope.path = '/chat';
		$scope.path = $rootScope.path;
		$rootScope.modelName = 'chat';
		$scope.pathTemplate = 'chat';
		$scope.title = 'Mesaje dispecerat - bucatarii';
		angular.extend(this, $controller('crudController', {$scope: $scope}));

		$scope.sortType = 'created_at';
		$scope.defaultItem = 10;
		$rootScope.typeId = 'id';
		$scope.classAction = 'td-big';
		$scope.columns = {
			//'id':{'label':'Id', 'filter':1, 'filterType':'input'},
			'date':{'label': 'Data', 'filter': 0, 'filterType': 'input'},
			'role_name': {'label': 'Dispeceri', 'filter': 1, 'filterType': 'input'}
		};
		$scope.additionals['publicUserPath'] = '/images/users';
		$scope.additionals['publicUserPath'] = '/images/users';
		$scope.additionals['publicUserPath180'] = $scope.additionals['publicUserPath']+'/thumb180x180';
		$scope.additionals['publicUserPath250'] = $scope.additionals['publicUserPath']+'/thumb250x250';
		$scope.additionals['publicUserPath'] = '/images/users';

		$scope.search.order = 'desc';
		$scope.additionals['content_type'] = 'form-urlencoded';

		/* get dependent fields */
		$scope.getDependedFields = function () {
			Crud.getDependedFields($scope.path)
				.success(function (data) {
					$scope.additionals['kitchens'] = data.kitchens;
					$scope.additionals['seeAllChat']('role', 'kitchen', 2, $scope.additionals['kitchens'][0].id);
				});
		}

		$scope.additionals['searchTerm'];
		$scope.additionals['clearSearchTerm'] = function() {
			$scope.additionals['searchTerm'] = '';
		};
		$scope.additionals['onSearchChange'] = function(ev) {
			ev.stopPropagation();
		};

		$scope.maxDate = new Date();
		$scope.minDate = '2010-01-01';
		var current_init_date = new Date();
		current_init_date.setHours(0, 0, 0, 0);
		$scope.search.dateFrom = current_init_date;

		$scope.controlSH = true;
		$scope.action = 'chat';

		/* delete model */
		$scope.deleteModel = function (ev, path, model) {
			$scope.additionals['invalid'] = '';
			$scope.modelData = {};
			$mdDialog.show({
				controller: DialogController,
				templateUrl: 'deleteDialog.tmpl.html',
				parent: angular.element(document.body),
				targetEvent: ev,
				clickOutsideToClose: true,
				locals: {pathTemplate: $scope.pathTemplate, model: model, additionals: $scope.additionals, path: path}
			}).then(function (destroyModel) {
				var no_pages = Math.ceil(($scope.total - 1) / $scope.state.itemsPerPage);
				if ($scope.state.page > no_pages) {
					$scope.state.page = no_pages;
				}
				if($scope.state.itemsPerPage == 0) {
					var position = $scope.models.map(function (e) {
						return e[$rootScope.typeId];
					}).indexOf(model[$rootScope.typeId]);
					$scope.models.splice(position, 1);
				}
				if($scope.state.itemsPerPage != 0) {
					$scope.getPaginateModel(path, $scope.state.page, $scope.state.itemsPerPage);
				}
			});

			DialogController.$inject = ['$scope', '$mdDialog', 'pathTemplate', 'model', 'additionals', 'path'];
			function DialogController($scope, $mdDialog, pathTemplate, model, additionals, path) {
				$scope.pathTemplate = pathTemplate;
				$scope.cancel = function () {
					$mdDialog.cancel();
				};
				$scope.additionals = additionals;
				$scope.modelData = model;

				/* save a model */
				$scope.destroyModel = function () {
					$scope.additionals['buttonDisabled'] = true;
					$scope.isLoading = true;

					var post = model;
					post['route'] = 'destroy';
					Crud.post('form-urlencoded', post, path + '/destroy')
						.success(function (data) {
							if (!angular.isUndefined(data.invalid)) {
								$scope.additionals['invalid'] = data.invalid;
							} else {
								if (!angular.isUndefined($scope.additionals['functionResult'])) {
									$scope.additionals['functionResult'](ev, data);
								}
							}
							$scope.isLoading = false;
							$mdDialog.hide();
							$scope.additionals['buttonDisabled'] = false;
						})
						.error(function (data) {
							$scope.errors = data.errors;
							$scope.isLoading = false;
							$scope.additionals['buttonDisabled'] = false;
						});
				};
			}
		};

		/* delete multiple models */
		$scope.deleteMultipleModel = function (ev, path) {
			$scope.additionals['invalid'] = '';
			if ($scope.checkSelected($scope.selected, ev)) {
				$mdDialog.show({
					controller: DialogController,
					templateUrl: 'deleteMultipleDialog.tmpl.html',
					parent: angular.element(document.body),
					targetEvent: ev,
					clickOutsideToClose: true,
					locals: {pathTemplate: $scope.pathTemplate, selected:$scope.selected, selectedAll:$scope.selectedAll, additionals: $scope.additionals}
				}).then(function () {
					if (angular.isUndefined($scope.additionals['invalid']) || $scope.additionals['invalid'] == '') {
						if($scope.state.itemsPerPage == 0) {
							angular.forEach($scope.selected, function (item, index) {
								var position = $scope.models.map(function (e) {
									return e[$rootScope.typeId];
								}).indexOf(index);
								$scope.models.splice(position, 1);
							});
						}
						if($scope.state.itemsPerPage != 0) {
							$scope.getPaginateModel(path, $scope.state.page, $scope.state.itemsPerPage);
						}
					}
					$scope.selected = {};
				});
				DialogController.$inject = ['$scope', '$mdDialog', 'pathTemplate', 'selected', 'selectedAll', 'additionals'];
				function DialogController($scope, $mdDialog, pathTemplate, selected, selectedAll, additionals) {
					$scope.pathTemplate = pathTemplate;
					$scope.additionals = additionals;
					$scope.selected = selected;
					$scope.selectedAll = selectedAll;

					$scope.cancel = function () {
						$mdDialog.cancel();
					};

					$scope.destroyMultipleModel = function () {
						$scope.additionals['buttonDisabled'] = true;
						$scope.isLoading = true;

						var post = {};
						post['models'] = $scope.selected;
						post['route'] = 'deleteMultiple';

						Crud.post('form-urlencoded', post, path + '/deleteMultiple')
							.success(function (data) {
								if (!angular.isUndefined(data.invalid)) {
									$scope.additionals['invalid'] = data.invalid;
								} else {
									if (!angular.isUndefined($scope.additionals['functionResult'])) {
										$scope.additionals['functionResult'](ev, data);
									}
								}
								$scope.selectedAll = false;
								$scope.selected = {};
								$scope.isLoading = false;
								$mdDialog.hide();
								$scope.additionals['buttonDisabled'] = false;
							}).error(function (data) {
								$scope.errors = data.errors;
								$scope.isLoading = false;
								$scope.additionals['buttonDisabled'] = false;
							});
					};
				}
			}
		};

		/* show model */
		$scope.showModel = function (ev, path, model) {
			$scope.additionals['errors'] = {};
			$scope.history = model;
			if (angular.isUndefined( $scope.chat)) {
				 $scope.chat = {};
			}
		  $scope.chat.id_to = 0;
			$scope.additionals['modelsChat'] = [];
			$scope.action = 'show';

			if (angular.isUndefined($scope.additionals['selectedIndexKitchen'])) {
				$scope.additionals['selectedIndexKitchen'] = 0;
			}
			model.id_to = $scope.additionals['kitchens'][$scope.additionals['selectedIndexKitchen']].id;

			if ($scope.mode_action == 'page') {
					$scope.controlSH = true;

					$scope.additionals['invalid'] = '';
					$scope.modelData = {};
					$scope.modelData = model;

					$scope.additionals['buttonDisabled'] = true;
					$scope.isLoading = true;

					var post = model;
					post['route'] = 'show';
					Crud.post('form-urlencoded', post, path + '/show')
						.success(function (data) {
							if (!angular.isUndefined(data.invalid)) {
								$scope.additionals['invalid'] = data.invalid;
							} else {
									//$scope.chat = data;
									$scope.additionals['modelsChat'] = data;
							}
							$scope.isLoading = false;
							$mdDialog.hide();
							$scope.additionals['buttonDisabled'] = false;
						})
						.error(function (data) {
							$scope.errors = data.errors;
							$scope.isLoading = false;
							$scope.additionals['buttonDisabled'] = false;
						});
			}
			if ($scope.mode_action == 'dialog') {
						var post = model;
						post['route'] = 'show';
						Crud.post('form-urlencoded', post, path + '/show')
								.success(function (data) {
										$mdDialog.show({
												controller: DialogController,
												templateUrl: 'showDialog.tmpl.html',
												parent: angular.element(document.body),
												targetEvent: ev,
												clickOutsideToClose: true,
												locals: {
														pathTemplate: $scope.pathTemplate,
														model: data,
														formatText: $scope.formatText,
														formatDate: $scope.formatDate,
														columns: $scope.columns,
														additionals: $scope.additionals,
														action: $scope.action,
														history: $scope.history,
														chat: $scope.chat
												},
										});
										DialogController.$inject = ['$scope', '$mdDialog', 'pathTemplate', 'model', 'formatText', 'formatDate', 'columns', 'additionals', 'action', 'history', 'chat'];
										function DialogController($scope, $mdDialog, pathTemplate, model, formatText, formatDate, columns, additionals, action, history, chat) {
												$scope.pathTemplate = pathTemplate;
												$scope.modelData = model;
												$scope.additionals = additionals;
												$scope.formatText = formatText;
												$scope.formatDate = formatDate;
												$scope.columns = columns;
												$scope.currency = $rootScope.currency;
												$scope.action = action;
												$scope.history = history;
												$scope.chat = chat;

												$scope.cancel = function () {
														$mdDialog.cancel();
												};
										}
										$scope.additionals['buttonDisabled'] = false;
								}).error(function (data) {
											$scope.errors = data.errors;
											$scope.additionals['buttonDisabled'] = false;
											if (data == null) {
													$rootScope.checkNetworkConnection();
											}
											if (!angular.isUndefined($scope.additionals['functionResult'])) {
													$scope.additionals['functionResult'](ev, data);
											}
									});
						}

		};

		$scope.actionLabel = 'Chat';
		$scope.cancel = function () {
			$scope.action = 'chat';
			$scope.currentUser = {};
			$scope.currentUserClass = {};
			//$scope.additionals['modelsChat'] = [];
			$scope.chat = {};
			$scope.additionals['errors'] = {};
			$scope.history = {};
			$scope.additionals['selectedIndexKitchen'] = 0;
			$scope.additionals['seeAllChat']('role', 'kitchen', 2, $scope.additionals['kitchens'][0].id);
		}

		$scope.getUsers = function () {
			Crud.get($scope.path+'/getUsers')
				.success(function (data) {
					$scope.users = data;
				});
		}
		//$scope.getUsers();

		$scope.chat = {};
		$scope.selectUser = function (user, keyUser) {
			$scope.currentUser = user;
			//$scope.users[keyUser]['no_unread_message'] = 0;
			$scope.currentUserClass = {};
			$scope.currentUserClass[user.id] = 'user-active';

			$scope.chat = {};
			$scope.additionals['modelsChat'] = [];
			$scope.additionals['errors'] = {};
		};

		$scope.additionals['sendChatMessage'] = function (entity_from, entity_to, id_from, id_to, message) {

				$scope.additionals['buttonDisabled'] = true;
				if(!Array.isArray(id_to)) {
					var id_to = [id_to];
				}
				var post = {};
				post['id_to'] = id_to;
				post['id_from'] = id_from;
				post['message'] = message;
				post['route'] = 'store';
				post['entity_from'] = entity_from;
				post['entity_to'] = entity_to;

				Crud.post('form-urlencoded', post, 'chat/store')
						.success(function (data) {
								$scope.chat.message = '';
								$scope.additionals['errors'] = {};
								$scope.isLoading = false;
								$timeout(function () {
                    $scope.additionals['buttonDisabled'] = false;
                }, 500);
						})
						.error(function (data) {
								$scope.additionals['errors'] = data.errors;
								$scope.isLoading = false;
								$timeout(function () {
                    $scope.additionals['buttonDisabled'] = false;
                }, 500);
								if (data == null) {
										$rootScope.checkNetworkConnection();
								}
						});
		};

		$scope.additionals['seeAllChat'] = function (entity_from, entity_to, id_from, id_to, date) {
			if (angular.isUndefined($scope.additionals['selectedIndexKitchen'])) {
				$scope.additionals['selectedIndexKitchen'] = 0;
			}

			$timeout(function () {
					var elem = document.getElementById('chat-message-'+id_to);
					if (!angular.isUndefined(elem) && elem != null && elem != 'null') {
							elem.focus();
					}
			}, 500);

			var post = {};
			post['route'] = 'getChat';
			post['id_from'] = id_from;
			post['id_to'] = id_to;
			post['entity_from'] = entity_from;
			post['entity_to'] = entity_to;
			if (!angular.isUndefined(date)) {
				  post['date'] = date;
			}

			Crud.post('form-urlencoded', post, $scope.path+'/getChat')
					.success(function (data) {
							$scope.additionals['modelsChat'] = data;
							$scope.isLoading = false;
							$scope.additionals['buttonDisabled'] = false;
							//$scope.getUsers();
							$timeout(function () {
								var target = angular.element(document.querySelector('#custom-scroller-'+id_to));
								target.animate({scrollTop: $('#div-scroll-'+id_to).height() + 50}, 'slow');
							}, 500);
					})
					.error(function (data) {
							$scope.isLoading = false;
							$scope.additionals['buttonDisabled'] = false;
							if (data == null) {
									$rootScope.checkNetworkConnection();
							}
					});
		}

		/* mqtt */
		Mqtt.addListener({'id': 'chat_channel', 'funct': chatMqtt});

		function chatMqtt(result, channel) {
				// console.log(channel)
				// console.log(result)

				if (angular.isUndefined($scope.additionals['modelsChat'])) {
					 $scope.additionals['modelsChat'] = [];
				}
				$scope.additionals['modelsChat'].push(result[0]);

				$timeout(function () {
					if(result[0].entity_to == 'kitchen') {
							var target = angular.element(document.querySelector('#custom-scroller-'+result[0].id_to));
							target.animate({scrollTop: $('#div-scroll-'+result[0].id_to).height() + 50}, 'slow');
					}
					if(result[0].entity_from == 'kitchen') {
							var target = angular.element(document.querySelector('#custom-scroller-'+result[0].id_from));
							target.animate({scrollTop: $('#div-scroll-'+result[0].id_from).height() + 50}, 'slow');
					}
				}, 500);

		}
		/* end mqtt */

	}]
);
